/* Source: src/mt-includes/widgets/integrations/src/frontend/init.frontend.js*/
angular.module('website.widget.integrations', [
    'website.widget.integrations.acuity_scheduling',
    'website.widget.integrations.airbnb',
    'website.widget.integrations.opentable'
]);
